"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProviderNotFetched = exports.isWaitlistDataNotFetched = void 0;
const isWaitlistDataNotFetched = (context) => {
    return context.waitlist === undefined;
};
exports.isWaitlistDataNotFetched = isWaitlistDataNotFetched;
const isProviderNotFetched = (context) => {
    return context.provider === undefined;
};
exports.isProviderNotFetched = isProviderNotFetched;
const guards = {
    isWaitlistDataNotFetched: exports.isWaitlistDataNotFetched,
    isProviderNotFetched: exports.isProviderNotFetched
};
exports.default = guards;
//# sourceMappingURL=guards.loadingMachine.js.map